import { memo } from "react"
import CarouselEdit from "./Carousel/CarouselEdit"
import GridEdit from "./Grid/GridEdit"

const propsAreEqual = (prevProps, nextProps) => {
  if (nextProps.layout !== prevProps.layout) return false
  if (nextProps.data !== prevProps.data) return false
  if (nextProps.style !== prevProps.style) return false
  return true
}

const GalleryEdit = memo((props) => {
  const { layout } = props

  if (layout === "grid" || layout === "grid-2") {
    return <GridEdit {...props} columns={layout === "grid-2" ? 2 : 3} />
  }

  return <CarouselEdit {...props} />
}, propsAreEqual)

export default GalleryEdit
